import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { HotCatService2, HotCatStatus } from 'src/app/core/services/hot.cat.2.service';
import { KaikasService, LoginInfo } from 'src/app/core/services/kaikas.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-hot-cat',
  templateUrl: './hot-cat.component.html',
  styleUrls: ['./hot-cat.component.scss']
})
export class HotCatComponent implements OnInit {
  private onStatus?:Subscription;
  private onLoginSubscription?:Subscription;

  public hasAllowance:boolean = false;
  public addressAllowance:string = "";
  public status:Observable<HotCatStatus>;
  public currentUser:string = "";


  displayedColumns: string[] = ['address', 'timeHold', 'CATC'];

  constructor(
    private hotCatService: HotCatService2,
    private kaikas: KaikasService
  ) { }

  public bid() {
    this.hotCatService.bid(environment.contractHotCat);
  }

  public approve() {
    this.hotCatService.makeAllowance(environment.contractHotCat).pipe(take(1)).subscribe({
      complete: ()=>{
        this.refreshAllowance();
      }
    });
  }

  public refresh() {
    this.hotCatService.refreshStatus(environment.contractHotCat);
  }

  ngOnInit() {
    this.status = this.hotCatService.status(environment.contractHotCat)!;
    this.onStatus = this.hotCatService.status(environment.contractHotCat)?.subscribe((data:HotCatStatus)=>{

    });

    this.hotCatService.refreshStatus(environment.contractHotCat);
    this.onLoginSubscription = this.kaikas.loginInfoObserver.subscribe((loginInfo:LoginInfo)=>{
      this.currentUser = loginInfo.address;
      if (this.hasAllowance == false || this.addressAllowance != this.currentUser)
        this.refreshAllowance();
    });

  }

  public refreshAllowance() {
    this.hotCatService.hasAllowanceToBid(environment.contractHotCat).pipe(take(1)).subscribe((hasAllowance)=>{
      this.hasAllowance = hasAllowance;
      if (hasAllowance == true)
        this.addressAllowance = this.currentUser;
    });
  }

  ngOnDestroy() {
    this.onStatus?.unsubscribe();
    this.onLoginSubscription?.unsubscribe();
  }
}
